import { GET_PRODUCTS_USER, GET_USER_PRODUCT_DETAIL_FIELDS, GET_USER_PRODUCT_DETAIL } from "@/views/users/store/types";

import { getField } from "vuex-map-fields";

const getters = {
  [GET_PRODUCTS_USER]: state => state.productsUser,
  [GET_USER_PRODUCT_DETAIL_FIELDS]: (state) => getField(state.product),
  [GET_USER_PRODUCT_DETAIL]: (state) => state.product,
};

export default getters;
